/* eslint-disable */
import IStat from "./IStat";
import LayerConfig from "./LayerConfig";
import LayerStyleComplex from "./LayerStyleComplex";
import StyleRule from "./style/StyleRule";

 


export default class Indicator {
    
    attributeName!: string;
    
    labelAttribute!: string;

    textContent!: string;

    layer!:LayerConfig;

    textSelectContent!: string;

    colorPalette!: string;

    graphType!: string;

    nbColors!:number

    active = true;

    useColorFromAnalyse=false;

    filterData:any;

    label?: string;

    edit=false;

    stats:any;

    showCenterObject=false;

    currentTextContent:string='';

    currentSelectContent:string='';

    chart:any;

    constructor(input: any = null) {
      if (input) {
        Object.assign(this, input);
      }
    }

    isGraph():boolean{
      return this.graphType!="textarea";
    }
    isTextArea():boolean{
      return this.graphType=="textarea";
    }
    
    computeStats(features: any,layer:LayerConfig) {
      if(this.graphType=="minmaxmean"){
        if(features && features.length>0){
          this.stats=this.getMinMaxMeanStats(features, this.attributeName);
        }else{
          this.stats={min:0,max:0,mean:0,count:0,sum:0};
        }
   
      }
      else if(this.graphType=="textarea"){

        this.stats=this.getMinMaxMeanStats(features, this.attributeName);
        this.currentTextContent=this.replaceContent(this.textContent,this.stats);
        
      }
      else{
        if(features && features.length>0){
          if(this.useColorFromAnalyse){
            this.stats=this.getCountStatsBasedOnAnalyse(features, this.attributeName,layer.complexStyle);
          }else{
            this.stats=this.getCountStats(features, this.attributeName);
          }
        }else{
          this.stats=[];
        }
      }
    }

    replaceContent(content:string,stats:any,feature?:any):string{
      console.log(stats);
      content=content.replace('{MAX}',stats.max);
      content=content.replace('{MIN}',stats.min);
      content=content.replace('{MEAN}',stats.mean);
      content=content.replace('{COUNT}',stats.count);
      if(feature){
        content=content.replace('{LABEL}',feature.get(this.labelAttribute));
        content=content.replace('{VALUE}',feature.get(this.attributeName));
      }
      return content;
    }
    getCountStatsBasedOnAnalyse(features: any, attributeName: string,complexAnalyse:LayerStyleComplex) {
      let stats:any[]=[];
      complexAnalyse.styleRules.forEach((rule:StyleRule)=>{
        stats.push({title:rule.label,count:0});
      });
      features.forEach((item: any) => {
        complexAnalyse.styleRules.forEach((rule:StyleRule,index:number)=>{
          if(rule.evaluateFeature(item)){
            stats[index].count+=1;
          }
        });}  );
      return stats;
    }
     getCountStats(features: any, attributeName: string) {
        let productStat = features.reduce((acc: any, item: any) => {
          const key = item.get(attributeName);
    
          if (!acc[key]) {
            acc[key] = { title: key || "", count: 0 };
          }
          acc[key].count += 1;
          return acc;
        }, {} as Record<string, { title: string; count: number }>);
    
        productStat = Object.values(productStat);
        return productStat;
    }
 getMinMaxMeanStats(features: any, attributeName: string):IStat {
    let productStat = features.reduce((acc: any, item: any) => {
      const key = item.get(attributeName);
      let value = Number(key)
      if (!acc["count"]) {
        acc["count"] = 0;
        acc["min"] = value;
        acc["max"] = value;
        acc["sum"] = 0;
        acc["mean"] = 0;
      }
      acc["count"] += 1;
      acc["sum"] += value;
      if (value < acc["min"]) {
        acc["min"] = value;
      }
      if (value > acc["max"]) {
        acc["max"] = value;
      }
      return acc;
    }, {} as Record<string, { title: string; count: number }>);

    productStat.mean = productStat.sum / productStat.count;
    productStat.sum = +productStat.sum.toFixed(2);
    productStat.min = +productStat.min.toFixed(2);
    productStat.max = +productStat.max.toFixed(2);
    productStat.mean = +productStat.mean.toFixed(2);
    return productStat;
  }
    clone() {
      return new Indicator(this.toJson());
    }
    
   

    toJson(): any {
      return {
        attributeName: this.attributeName,
        labelAttribute:this.labelAttribute,
        label: this.label,
        useColorFromAnalyse:this.useColorFromAnalyse,
        textContent:this.textContent,
        showCenterObject:this.showCenterObject,
        textSelectContent:this.textSelectContent,
        nbColors:this.nbColors,
        graphType: this.graphType,
        colorPalette: this.colorPalette,
      };
    }
}
